import React from 'react';
import Configurer from '../../../components/Configurer';
// import { checkTextTranslation } from '../../utils/useful'
import FormViewer from '../../../components/FormViewer';
import LoaderButton from '../../../components/LoaderButton';
import StagesManager from '../../../components/StagesManager';
import TLink from '../../../components/TLink';
import HttpServices from '../../../utils/Http.services';
import { checkTranslation, imageAddress, invoiceStatusConvertor, priceStandardView, translate } from '../../../utils/useful';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../../../stores/actionsList';
import { withRouter } from "react-router-dom";
import PageStatusViewer from '../../../components/PageStatusViewer';
import Collapsible from 'react-collapsible';
import TableViewer from '../../../components/TableViewer';
import moment from 'jalali-moment';
import ReactToPrint from 'react-to-print';
import ButtonAnimated from '../../../components/buttons/ButtonAnimated';
import AccountingInvoiceEdit from './AccountingInvoiceEdit';

class AccountingInvoice extends React.Component {

    state = {

        paymentsHeaders: [
            { key: 'date', type: 'DateInput', col: '6', information: { label: '{{lang}}applets.accounting.invoiceDate', placeholder: '{{lang}}applets.accounting.invoiceDate', required: true }, showMain: true },
            { key: 'number', type: 'TextInput', col: '12', information: { label: '{{lang}}number', placeholder: '{{lang}}number', required: false, disabled: true }, showMain: true },
            { key: 'mode', type: 'SelectInput', fullCol: true, information: { label: '{{lang}}Payment mode', required: true, type: 'local', default: '0', items: [{ title: "{{lang}}Cash", value: 'C', color: '#789' }, { title: "{{lang}}Credit Card", value: 'CC', color: '#789' },] }, showMain: true, inExport: true },
            { key: 'amount', type: 'PriceInput', col: '12', information: { label: '{{lang}}amount', placeholder: '{{lang}}amount', required: false, disabled: true }, showMain: true },

        ],
        invoiceHeaders: [
            { key: 'item', type: 'AdvancedSelectInput', col: '4', information: { label: '{{lang}}applets.accounting.itemDetails', address: 'ygetProducts', filter: { appletHub: '{{appletHub}}' }, fields: { title: 'name', image: 'images', value: '_id', price: 'price', unit: 'unit' }, type: 'api', isSearchable: true, placeholder: '{{lang}}product', required: false }, showMain: true },
            { key: 'quantity', type: 'NumberInput', col: '3', information: { label: '{{lang}}useful.quantity', placeholder: '{{lang}}useful.count', required: true } },
            { key: 'rate', type: 'PriceInput', col: '2', information: { label: '{{lang}}useful.rate', placeholder: '{{lang}}useful.rate', required: true } },
            { key: 'amount', type: 'PriceInput', col: '3', information: { label: '{{lang}}useful.amount', disabled: true, placeholder: '{{lang}}useful.amount', required: true } },

        ],
        // headersAccount: [
        //     { key: 'Account', type: 'SelectInput', col: '6', information: { label: '{{lang}}Account', address: 'getAccounts', filter: { applet: '{{appletId}}', appletHub: "{{appletHub}}" }, fields: { title: 'name', value: '_id' }, type: 'api', isSearchable: true, placeholder: '{{lang}}Select  Account', required: false }, showMain: false },            
        //     { key: 'depositTo', type: 'SelectInput', col: '6', information: { label: '{{lang}}Deposit To', address: 'getAccounts', filter: { applet: '{{appletId}}', appletHub: "{{appletHub}}" }, fields: { title: 'name', value: '_id' }, type: 'api', isSearchable: true, placeholder: '{{lang}}Deposit to', required: false }, showMain: false },            
        // ],
        paymentsData: []
        // formHeaders: [
        //     { key: 'images', type: 'ImageInput', information: { label: '{{lang}}images', placeholder: '{{lang}}image', placeHolderImage: '', defaultImage: 'https://wallpaperaccess.com/full/3504847.jpg', required: false, cropper: true, single: false } },
        //     { key: 'date', type: 'DateInput', information: { label: '{{lang}}date', placeholder: '{{lang}}date', required: true } },

        //     { key: 'person', type: 'TextInput', information: { label: '{{lang}}person', spellCheck: false, placeholder: '{{lang}}person', required: true } },

        //     {
        //         type: 'SubformInput',
        //         key: 'items',
        //         information: {
        //             label: '{{lang}}items',
        //             headers: [
        //                 { key: 'Product', type: 'TextInput', col: '4', information: { label: '{{lang}}product', placeholder: '{{lang}}product', required: true, } },
        //                 { key: 'amount', type: 'PriceInput', col: '4', information: { label: '{{lang}}amount', placeholder: '{{lang}}amount', required: true } },
        //                 { key: 'count', type: 'PriceInput', col: '4', information: { label: '{{lang}}count', placeholder: '{{lang}}count', required: true } },
        //             ],

        //             placeholder: '{{lang}}placeholders.insertInformation',
        //             required: true
        //         },
        //         showMain: false
        //     },

        //     { key: 'discount', type: 'PriceInput', information: { label: '{{lang}}discount', placeholder: '{{lang}}discount', required: false } },
        //     { key: 'tax', type: 'PriceInput', information: { label: '{{lang}}tax', placeholder: '{{lang}}tax', required: false } },

        //     // { key: 'amount', type: 'TextInput', information: { label: '{{lang}}name', placeholder: '{{lang}}name', required: true } },

        //     { key: 'description', type: 'TextAreaInput', information: { label: '{{lang}}description', placeholder: '{{lang}}description', required: false } }

        // ]
    }

    componentDidMount() {

        // let search = this.props.location.search;
        // let params = new URLSearchParams(search);
        // let id = params.get('id');
        // if (id) {
        //     this.fetch(id)

        // } else {
        //     this.setState({ pageStatus: 200 }, () => {
        //         this.stageManager.changeStage('edit')
        //     })
        // }


        let _id = this.props.windowData?.path[this.props.baseUrl?.length]
        this.setState({ _id })
        if (_id != "new" && _id != null) {

            this.fetch(_id)

            // this.stageManager.changeStage('edit')
            // HttpServices.request('getFrame', { _id: _id }, (fetchResult, fetchError) => {
            //     console.log('fethcresult1-', fetchResult.info)
            //     this.setState({ _id: _id, initData: fetchResult.info.page, name: fetchResult.info.name },()=>[
            //         this.props.setHeader("dummy",1)
            //     ])
            // })
        } else {
            this.stageManager.changeStage('edit')
        }


        if (this.props.setHeader) {
            this.props.setHeader({
                // 'toolbar': this.toolbarComponent,
                'showToolbar': true,
                topHeaderComponent: this.topHeaderComponent,
                backAction: () => this.props.changePage('invoices')

            })
        }


    }


    topHeaderComponent = () => {
        return (
            <div className='flexc'>

                <ButtonAnimated
                    iconwidth='24px'
                    onClick={this.postInvoice}
                    title='{{lang}}Save'
                    icon='/assets/icons/plus-white.svg'
                    textColor={this.props.colors?.iconInvert ? '#fff' : '#000'}
                    invert={!this.props.colors?.iconInvert}
                    bg={this.props.colors?.iconInvert ? '#000' : '#fff'}
                />

            </div>
        )
    }


    // topHeaderComponent = () => {
    //     return (
    //         <div className='flexc'>
    //             <div className='px-2'>
    //                 <PageBuilderAddElements type={this.state.type} componentsInfo={this.state.componentsInfo[this.state.type]} onDragStartAction={this.onDragStartAction} />
    //             </div>

    //             <ButtonAnimated
    //                 iconwidth='24px'
    //                 onClick={this.savePage}
    //                 title='Save'
    //                 icon='/assets/icons/plus-white.svg'
    //                 textColor={this.props.colors?.iconInvert ? '#fff' : '#000'}
    //                 invert={!this.props.colors?.iconInvert}
    //                 bg={this.props.colors?.iconInvert ? '#000' : '#fff'}
    //             />

    //         </div>

    //     )
    // }




    fetch = (id) => {
        // this.setState({ isLoading: true, errors: {} })
        console.log("fetch Invoice")
        // if (this.form) {
        //     let data = this.form.getForm()

        //     console.log(data)
        //     if (data) {
        this.setState({ isLoading: true, errors: {} })
        //         data.applet = this.props.applet._id
        if (this.state.invoice?._id) {
            id = this.state.invoice?._id
        }

        HttpServices.request("getInvoice", { id }, (fetchResult, fetchError) => {

            this.setState({ isLoading: false })
            console.log("fetchResult, ",fetchResult)
            console.log(fetchError)

            if (fetchError) {
                // cb(false, fetchError.message)
                // this.setState({ error: fetchError.message })
                this.setState({ pageStatus: 404 })

                return
            }

            if (fetchResult.info) {

                let payments = []

                if (Array.isArray(fetchResult.payments)) {
                    fetchResult.payments.forEach(payment => {
                        let amount = payment.list[0].amount
                        payments.push({ ...payment, ...{ amount } })
                    });
                }

                this.setState({ invoice: fetchResult.info, paymentsData: payments, pageStatus: 200 }, () => {
                    this.stageManager.changeStage('view')
                    // window.scrollTo({ top: 0, behavior: 'smooth' })
                })


                // console.log(fetchResult.info)
                // this.stageManager.nextStage()
            }

        })

        //     }
        // }
    }


    postInvoice = () => {
        // this.setState({ isLoading: true, errors: {} })
        console.log("postInvoice")
        if (this.AccountingInvoiceEdit?.form) {
            let data = this.AccountingInvoiceEdit?.form.getForm()
            if (data) {
                this.setState({ isLoadingPost: true, errors: {} })
                data.applet = this.props.applet._id
                data.appletHub = this.props.variables.appletHub
                let address = "postInvoice"

                if (data._id) {
                    address = "editInvoice"
                }
                // console.log(address)
                HttpServices.request(address, data, (fetchResult, fetchError) => {

                    console.log('fetchResult', fetchResult)
                    console.log('fetchError', fetchError)

                    this.setState({ isLoadingPost: false })


                    if (fetchError) {
                        this.setState({ error: fetchError.message })
                        return
                    }

                    if (fetchResult.info) {

                        // console.log("success")
                        this.setState({ success: true, invoice: fetchResult.info }, () => {
                            this.stageManager.changeStage('view')
                            // window.scrollTo({ top: 0, behavior: 'smooth' })
                        })

                        // console.log(this.state._id)
                        if (this.state._id == 'new' || this.state._id == null) {
                            let newLink = this.props.baseUrl.splice(2)
                            newLink.push(fetchResult?.info?._id)

                            this.props.changeWindowLink(newLink)
                            this.setState({ _id: fetchResult?.info?._id, })
                        }

                    }


                })

            }
        }
    }



    fetchSalesPerson = (customer) => {

        let body = {
            customer,
            applet: this.props.applet._id,
            appletHub: this.props.variables.appletHub
        }


        // console.log(body)

        HttpServices.request('getSalesPerson', body, (fetchResult, fetchError) => {

            // console.log(fetchResult)

            this.setState({ isLoadingPost: false })


            if (fetchError) {
                this.setState({ error: fetchError.message })
                return
            }

            if (!fetchResult.info) {
                fetchResult.info = {}
            }

            let invoice = { ...this.state.invoice }

            invoice.salesperson = fetchResult.info.salesperson

            invoice.commission = fetchResult.info.commission

            this.setState({ invoice })

            // console.log("success")
            // this.setState({ success: true, invoice: fetchResult.info }, () => {
            //     this.stageManager.changeStage('view')
            // })



        })


    }

    liveChange = (data, init, key, value, extra) => {
        this.setState({ invoice: data })

        if (key == 'customer') {
            // console.log(value)
            this.fetchSalesPerson(value)
        }
        // console.log(data)
    }

    cancel = () => {
        // if (this.state.invoice?._id) {
        //     this.fetch()
        // } else {

        //     let search = this.props.location.search;
        //     let params = new URLSearchParams(search);
        //     let ref = params.get('ref');
        //     if (ref && ref !== '') {
        //         // console.log(ref)
        //         this.props.history.push(ref)
        //     } else {
        //         this.props.history.goBack()
        //     }
        // }
        this.stageManager.changeStage('view')
    }

    goForPayment = (e) => {

        e.stopPropagation()
    }



    render() {
        return (


            <section className="h-100  w-100  scroll-no-scrollbar flexc flex-column" style={{ backgroundColor: '#f0f0f0' }}>
                <div className='w-100 mt-4 br-10 mb-5' style={{ maxWidth: 800, backgroundColor: '#fff' }}>
                    <div className="w-100 px-3 pt-0" >

                        <div className="w-100">

                            {this.state.invoice?.number && (
                                <>
                                    <div className="flexc col-12 col-md-6">
                                        {/* <div className="mrd-4 flexcc">
                                                <img src={'/images/icons/' + this.props.applet?.type + ".svg"} style={{ border: '3px solid #ffffff50', height: 30, width: 30, objectFit: 'cover', borderRadius: '50%', border: '1px solid #eeeeee10', boxShadow: '0px 0px 15px #00000020' }} />
                                            </div> */}
                                        <div>
                                            {/* <TLink to={'/' + (this.props.applet?.user?.username ?? ('p/' + this.props.applet?.user?._id))} >
                                                                                                    <p className="text-normal mt-1" style={{ color: '#ffffffdd' }}>{this.props.applet?.user?.fullname}</p>
                                                                                                                                                    </TLink>> */}

                                            {/* <p className="text-normall" style={{ color: '#fff' }}>{"# " + this.state.invoice?.number}</p> */}

                                            {/* <p className="mt-1 text-smaller" style={{ color: '#ffffffdd' }}>{this.props.applet?.name}</p> */}
                                        </div>
                                    </div>

                                    <div className="flexc col-12 col-md-6 d-flex justify-content-md-end mt-4 mt-md-0">
                                        <div className=" d-flex " style={{ border: '1px solid #fff', boxShadow: '0px 0px 30px #00000020', borderRadius: 8,background: invoiceStatusConvertor(this.state.invoice?.status)?.background, padding: '3px 8px' }}>
                                            {/* <div> */}
                                            <div className="w-100 flexcc flex-column">
                                                <span className="text-normal text-uppercase" style={{ color: invoiceStatusConvertor(this.state.invoice?.status)?.color  }}>{checkTranslation(invoiceStatusConvertor(this.state.invoice?.status)?.title)}</span>
                                                {/* <p className="text-smaller mt-0">Status</p> */}
                                                {/* <p className="text-smaller opacity-5 ">Create Invoice Stage</p> */}
                                            </div>
                                            {/* </div> */}
                                        </div>
                                    </div>
                                    <div className="w-100 mt-1 flexc py-1" style={{ color: '#fff', padding: '0px 10px', backgroundColor: 'rgba(0,0,0,0.2)' }}>

                                        <button onClick={() => { this.stageManager.changeStage('edit'); window.scrollTo({ top: 0, behavior: 'smooth' }) }} className="flexc text-white text-small prd-2" ><img className="mrd-2" src="/assets/icons/edit.png" height="18px" />{translate('edit')}</button>
                                        <button className="flexc text-white text-small px-2" ><img className="mrd-2" src="/assets/icons/share2.png" height="18px" />{translate('share')}</button>
                                        {/* <button className="flexc text-small px-2" ><img className="mrd-2" src="/images/3799967.svg" height="20px" />{translate('PDF/Print')}</button> */}
                                        <div>
                                            <ReactToPrint
                                                trigger={() => {
                                                    return <button className="flexc text-white text-small px-2" ><img className="mrd-2" src="/assets/icons/printer.png" height="20px" />{translate('PDF/Print')}</button>

                                                }}
                                                content={() => this.printRef}
                                                documentTitle='Invoice'
                                                pageStyle="pdf"
                                                onAfterPrint={() => console.log('document prited')}
                                            />
                                        </div>

                                    </div>
                                </>
                            )}



                            {/* <div className="col-12" style={{ height: 100 }}>

                                </div> */}
                        </div>
                    </div>
                    <div className="pt-0 w-100 " style={{ minHeight: 'calc(100vh - 100px)', margin: '0px 0px', border: '1px solid #eee', position: 'relative', borderRadius: '0px 0px 0px 0px', boxShadow: '0px 0px 0px #00203020' }}>


                        <StagesManager fast={true} ref={el => this.stageManager = el} >
                            <div>
                                <ReactToPrint
                                    trigger={() => {
                                        return <button className="flexc text-small py-2 px-2" style={{ borderRight: '1px solid #e0e0e2' }}><img className="mrd-2" src="/images/3799967.svg" height="20px" />{translate('PDF/Print')}</button>

                                    }}
                                    content={() => this.printRef}
                                    documentTitle='Invoice'
                                    pageStyle="pdf"
                                    onAfterPrint={() => console.log('document prited')}
                                />
                            </div>
                            <div stage={1} stageName={'view'} className="col-12 p-0 pb-5 d-flex flex-column w-100 container" style={{ justifyContent: 'center', opacity: this.state.mainOpacity, transition: 'all 0.5s', flex: '1 1 auto', paddingTop: 0 }}>

                                {/* <div className="w-100 flexc" style={{ borderBottom: '1px solid #eee', color: '#789', padding: '0px 20px', backgroundColor: '#f2f6f8', borderRadius: '0px 0px 0px 0px' }}>

                                        <button onClick={() => { this.stageManager.changeStage('edit'); window.scrollTo({ top: 0, behavior: 'smooth' }) }} className="flexc text-normal py-2 px-2" style={{ borderRight: '1px solid #e0e0e2' }}><img className="mrd-2" src="/images/3799967.svg" height="20px" />{translate('edit')}</button>
                                        <button className="flexc text-normal py-2 px-2" style={{ borderRight: '1px solid #e0e0e2' }}><img className="mrd-2" src="/images/3799967.svg" height="20px" />{translate('share')}</button>
                                        
                                        <div>
                                            <ReactToPrint
                                                trigger={() => {
                                                    return <button className="flexc text-normal py-2 px-2" style={{ borderRight: '1px solid #e0e0e2' }}><img className="mrd-2" src="/images/3799967.svg" height="20px" />{translate('PDF/Print')}</button>

                                                }}
                                                content={() => this.printRef}
                                                documentTitle='Invoice'
                                                pageStyle="pdf"
                                                onAfterPrint={() => console.log('document prited')}
                                            />
                                        </div>

                                    </div> */}


                                <div className="px-4 py-4 container ">
                                    {/* {console.log('salar payment', this.state.paymentsData)} */}
                                    {this.state.paymentsData?.length ? (
                                        <div className="px-3" style={{ border: '1px solid #eee', borderRadius: 15, backgroundColor: '#fff' }}>
                                            <div className="flexcb w-100 cursor-pointer py-3" onClick={() => this.setState({ showPayments: !this.state.showPayments })}>
                                                <div className="flexc">
                                                    <p className="text-bold text-small">{translate('Payments Received')} </p>
                                                    <span className="flexcc text-small white mx-2" style={{ backgroundColor: '#007aff', borderRadius: 18, height: 18, minWidth: 18 }}>{this.state.paymentsData?.length}</span>
                                                </div>
                                                <div className="flexc">
                                                    {this.state.invoice?.status != 'P' && (
                                                        <button onClick={(e) => this.goForPayment(e)} className="py-2 px-1 mx-2" style={{ backgroundColor: 'rgba(70, 133, 204, 0.796)', borderRadius: 9 }}>
                                                            <p className="white text-small">{translate('Submit Payment')}</p>
                                                        </button>
                                                    )}

                                                    <img className={"opacity-5" + (this.state.showPayments ? ' rotate-90' : '')} src="/images/arrow-a.svg" height="12px" style={{ transition: '0.5s' }} />
                                                </div>

                                            </div>
                                            <Collapsible open={this.state.showPayments}>
                                                <div className="pb-3 pt-0" >
                                                    <TableViewer headers={this.state.paymentsHeaders} data={this.state.paymentsData} top={0} />
                                                </div>
                                            </Collapsible>
                                        </div>
                                    ) : (

                                        <div className="px-2" style={{ border: '1px solid #eee', backgroundColor: '#fff', borderRadius: 15 }}>
                                            <div className="flexcb w-100 py-2" onClick={() => this.setState({ showPayments: !this.state.showPayments })}>
                                                <div className="flexc">
                                                    <img src="/images/shield.svg" height="40px" />
                                                    <div className="mld-3">
                                                        <p className="text-bold text-small">{translate('Faster with online payment gateways')} </p>
                                                        <p style={{ color: '#789' }} className="text-smaller">{translate('Set up a payment gateway and start accepting payments online')} </p>

                                                    </div>
                                                </div>
                                                <button onClick={(e) => this.goForPayment(e)} className="py-2 px-2" style={{ background: 'rgb(0, 122, 255)', borderRadius: 9 }}>
                                                    <p style={{ whiteSpace: 'nowrap' }} className="white text-small">{translate('Submit Payment')}</p>
                                                </button>
                                            </div>

                                        </div>

                                    )}

                                    <div ref={el => this.printRef = el} className="flexc flex-column">
                                        <div className='w-100' style={{ maxWidth: 800 }}>

                                            <div className="mt-4" style={{ backgroundColor: '#fff', boxShadow: '0px 0px 30px #00000010', borderRadius: 15 }}>
                                                <div className="px-5 py-4">
                                                    <div className='d-flex justify-content-between'>
                                                        <div>
                                                            <img height={50} width={50} style={{ borderRadius: '100%', objectFit: 'cover' }} src={imageAddress(this.props.user?.info?.image, 'profile', 'thumb')} alt="" />
                                                            <p>{checkTranslation(this.state.invoice?.customer?.fullname)}</p>

                                                            <p className="text-small mt-3">{translate('Invoice Date')}</p>
                                                            {moment(this.state.invoice?.date).isValid() && (
                                                                <p className="text-normal mt-1">{moment(this.state.invoice?.date).local('fa').format('YYYY/MM/DD')}</p>
                                                            )}
                                                            {this.state.invoice?.dueDate && moment(this.state.invoice?.dueDate).isValid() && (
                                                                <>
                                                                    <p className="text-small mt-3">{translate('Due Date')}</p>
                                                                    <p className="text-normal mt-1">{moment(this.state.invoice?.dueDate).local('fa').format('YYYY/MM/DD')}</p>
                                                                </>
                                                            )}
                                                        </div>
                                                        <div>
                                                            <p className="text-ultra-big">{translate('Invoice')}</p>
                                                            <p className="text-small"># {this.state.invoice?.number}</p>

                                                            <p className="text-small mt-3">{translate('Balance Due')}</p>
                                                            <p className="text-normal mt-1">{priceStandardView(this.state.invoice?.balanceDue)}</p>

                                                        </div>
                                                    </div>

                                                    <div className="mt-3">
                                                        <TableViewer headers={this.state.invoiceHeaders} data={this.state.invoice?.list?.items} top={0} actions={null} />

                                                    </div>
                                                    <div className="d-flex px-3 mt-3">
                                                        {/* <div style={{ flex: '1 0 150px' }}></div> */}
                                                        <div className="text-center w-100">
                                                            <p className="text-small text-start mb-2">{translate("Subtotal")}</p>
                                                            <p className="text-small text-start mb-2">{translate("Discount")}</p>
                                                            <p className="text-small text-start mb-2">{translate("Tax")}</p>
                                                            <p className="text-small text-start mb-2">{translate("Shipping")}</p>
                                                            {this.state.invoice?.list?.adjustment != null && this.state.invoice?.list?.adjustment != '' && this.state.invoice?.list?.adjustment != 0 && (
                                                                <p className="text-small text-start mb-2">{checkTranslation(this.state.invoice?.list?.adjustmentTitle) ?? translate("Adjustment")}</p>
                                                            )}
                                                            <p className="text-small text-start mb-2  text-bold">{translate("Total")}</p>
                                                            <p className="text-small text-start mb-2" style={{ color: '#ee5050' }}>{translate("Payments made")}</p>
                                                            <p className="text-small text-start mb-2" style={{ borderTop: '1px solid #eee', padding: '5px 0px' }}>{translate("Balance due")}</p>



                                                        </div>

                                                        <div className="text-center w-100">
                                                            <p className="text-small text-start mb-2">{priceStandardView(this.state.invoice?.list?.subtotal)}</p>
                                                            <p className="text-small text-start mb-2">{priceStandardView(this.state.invoice?.list?.discount)}</p>
                                                            <p className="text-small text-start mb-2">{priceStandardView(this.state.invoice?.list?.tax)}</p>
                                                            <p className="text-small text-start mb-2">{priceStandardView(this.state.invoice?.list?.shipping)}</p>
                                                            {this.state.invoice?.list?.adjustment != null && this.state.invoice?.list?.adjustment != '' && this.state.invoice?.list?.adjustment != 0 && (
                                                                <p className="text-small text-start mb-2">{priceStandardView(this.state.invoice?.list?.adjustment)}</p>
                                                            )}
                                                            <p className="text-small text-start mb-2 text-bold">{priceStandardView(this.state.invoice?.list?.total)}</p>
                                                            <p className="text-small text-start mb-2" style={{ color: '#ee5050' }}>(-) {priceStandardView(Number(this.state.invoice?.list?.total) - (Number(this.state.invoice?.balanceDue) ?? 0))}</p>
                                                            <p className="text-small text-start mb-2" style={{ borderTop: '1px solid #eee', padding: '5px 0px' }}>{priceStandardView(this.state.invoice?.balanceDue)}</p>


                                                        </div>
                                                    </div>
                                                    {this.state.invoice?.description != null && this.state.invoice?.description != '' && (
                                                        <div className="mt-3">
                                                            <p className="text-small mb-2">{translate('Note')}</p>
                                                            <p>{checkTranslation(this.state.invoice?.description)}</p>

                                                        </div>
                                                    )}

                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                            <AccountingInvoiceEdit stage={1} stageName={'edit'} ref={el => this.AccountingInvoiceEdit = el} page={this.props.page} colors={this.props.colors} variables={this.props.variables} applet={this.props.applet} postInvoice={this.postInvoice} isLoadingPost={this.state.isLoadingPost} width={this.props.width} />



                            <div stage={1} stageName={'success'} className="col-12 pb-5 flexc flex-column" style={{ opacity: this.state.mainOpacity, transition: 'all 0.5s', flex: '1 1 auto', paddingTop: 20 }}>
                                <div className="text-center" style={{ backgroundColor: '#007aff20', color: '#007aff', borderRadius: 8, padding: '20px 40px' }}>
                                    <p className="text-small">{translate('The invoice was registered successfully')}</p>
                                    <button onClick={() => this.stageManager.changeStage('view')} className="mt-2" style={{ backgroundColor: '#007aff', color: '#fff', borderRadius: 20, padding: '5px 20px' }}>{translate('Registration of a new invoice')}</button>
                                </div>
                            </div>


                        </StagesManager>

                    </div>

                </div>
            </section>


        )
    }
}


const mapStateToProps = state => ({ settings: state.settings, user: state.user, resource: state.resource, pages: state.pages })
const mapDispatchToProps = dispatch => ({ actions: bindActionCreators(actions, dispatch) })

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withRouter(AccountingInvoice));